import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import Backend from 'react-dnd-html5-backend'

// Components
import { BrowserRouter as Router } from 'react-router-dom'
import { DndProvider } from 'react-dnd'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { CssBaseline } from '@material-ui/core'
import ProgressProvider from 'Contexts/ProgressContext'
import Intercom from 'Containers/Intercom'
import NavConfirmation from 'Components/Dialog/NavConfirmation'
import ThemeProvider from 'Components/ThemeProvider'

// Navigation
import Routes from 'routes/Routes'

// Redux
import createStore from 'Redux/index'

// Styles
import './index.css'
import WebSocket from 'Containers/WebSocket'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

require('dotenv').config()

const { store, persistor } = createStore()

const queryClient = new QueryClient()

ReactDOM.render(
  <DndProvider backend={Backend}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <CssBaseline />
            <ProgressProvider>
              <Router getUserConfirmation={NavConfirmation}>
                <Fragment>
                  <Routes />
                  <WebSocket />
                </Fragment>
              </Router>
            </ProgressProvider>
          </ThemeProvider>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  </DndProvider>,
  document.getElementById('root'),
)
